import React from 'react';
import QrReader from '@components/QrReader';
import cn from 'classnames';
import constant from '@components/common/globalization';

const QrScanComp = ({
  // handleError,
  handleScan,
  code,
  sensorReg,
  setScanCode,
}) => {
  return (
    <>
      <div
        className={cn(
          'd-flex flex-column col-11 align-items-center justify-content-center h-100'
        )}
      >
        <QrReader
          onError={() => {}}
          onScan={handleScan}
          style={{ width: '100%' }}
        />
      </div>

      {code && (
        <div className="d-flex flex-column col-lg-6 offset-lg-3 col-sm-12 col-md-6 offset-md-3">
          <div className="px-3 mt-2 fs-26 text-center fw-600">Code: {code}</div>
        </div>
      )}

      {sensorReg && code && (
        <div className="row justify-content-center align-items-center mx-0 col-lg-4 offset-lg-4 col-sm-12 col-md-6 offset-md-3 mb-60 mt-10">
          <button
            type="button"
            onClick={() => {
              sensorReg({ externalId: code });
              setScanCode(null);
            }}
            className="btn btn-primary od-btn-primary btnWidth-200"
            aria-label="Register Sensor"
          >
            {constant.REGISTER_SENSOR}
          </button>
        </div>
      )}
    </>
  );
};

export default QrScanComp;
